


















































































































































import axios from 'axios';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import {
    CatalogOrderViewModel,
    Catalog,
    CatalogRequest
} from '@/models/Catalog';

import http from '@/services/Http';

@Component({
    components: {}
})
export default class CatalogOrder extends Vue {
    protected viewModel: CatalogOrderViewModel;
    protected selectedCatalogs: string[] = [];
    protected isLoaded: boolean = false;
    protected isSubmitted: boolean = false;
    protected isValid: boolean = true;

    protected firstName: string = '';
    protected lastName: string = '';
    protected email: string = '';
    protected address: string = '';
    protected zipCode: string = '';
    protected city: string = '';
    protected country: string = '';
    protected newsLetter: boolean = false;
    protected concentPolicy: boolean = false;
    protected concentPolicyMissing: boolean = false;

    constructor() {
        super();
        this.viewModel = JSON.parse(this.$attrs['data-content']);

        // console.log(this.viewModel);
        this.$attrs['data-content'] = '';
    }

    mounted() {
        this.updateSelected();
    }

    private updateSelected() {
        this.selectedCatalogs = [];

        this.viewModel.Catalogs.forEach(element=> {
            if (element.Selected == true) {
                this.selectedCatalogs.push(element.Title);
            }
        });
    }

    private submitForm() {
        // console.log('submit catalog');
        this.isValid = true;

        if (
            this.selectedCatalogs != null &&
            this.selectedCatalogs.length > 0 &&
            this.concentPolicy
        ) {
            const request: CatalogRequest = {
                Catalogs: this.selectedCatalogs,
                FirstName: this.firstName,
                LastName: this.lastName,
                Mail: this.email,
                Address: this.address,
                ZipCode: this.zipCode,
                City: this.city,
                Country: this.country,
                NewsLetter: this.newsLetter,
                ConcentPolicy: this.concentPolicy
            };

            const requestContext = (window as any).__litium.requestContext;

            axios({
                method: 'post',
                url: `/api/catalogorder`,
                data: request,
                headers: {
                    'litium-request-context': JSON.stringify(requestContext)
                }
            })
                .then((response: any) => {
                    this.isSubmitted = true;
                    const self = this;
                    setTimeout(function() {
                        self.isLoaded = true;
                    }, 600);
                })
                .catch((response: any) => {
                    // handle error
                    // console.log(response);
                    this.isValid = false;
                });
        } else if (!this.concentPolicy) {
            this.concentPolicyMissing = true;
        }
    }
}
